import { CreditStatusTableData } from 'src/services/models/credit.service';
import DetailsDrawer from 'src/components/credit/statusSearch/detailsDrawer/detailsDrawer';
import FooterPrivacy from '../../../auth/components/baseTemplate/FooterPrivacy';
import { getBrandByDealerNumber } from 'src/utils/helpers';
import { IUser } from '../../../../utils/interfaces/user';
import Search from 'src/components/credit/statusSearch/searchBar';
import Spinner from 'src/components/ui/spinner';
import Table from 'src/components/credit/statusSearch/table';
import TableFooter from 'src/components/table/pagination/tableFooter';
import { useLocalization } from 'src/utils/useLocalization';
import { useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import './styles.scss';

export enum CreditStatusTableSortType {
    APPLICANT_NAME,
    APPLICATION_NUMBER,
    COLLATERAL,
    STATUS,
    SUBMITTED_BY,
    SUBMITTED_DATE,
}

const NO_RESULTS = 0;
const DEFAULT_CREDIT_DETAILS = '-1';

const loader = (
    <div className='loader_container'>
        <Spinner />
    </div>
);

const NoContent: React.FC<{ failedSearchTerm: string }> = ({
    failedSearchTerm,
}) => {
    const { labelText } = useLocalization();

    return (
        <div className='no-content'>
            <div>
                {`${labelText.LABEL_TEXT_FUNDING_SEARCH_ERROR_NO_RESULTS} `}
                <span className='bold'>{failedSearchTerm}</span>
            </div>
            <div className='small-text'>
                {labelText.LABEL_TEXT_FUNDING_SEARCH_ERROR_SUGGESTION}
            </div>
        </div>
    );
};

const CreditStatus: React.FC = () => {
    const defaultDetail = {
        applicationId: DEFAULT_CREDIT_DETAILS,
        applicationNumber: NO_RESULTS,
    };
    const currentDealers = useSelector((state: IUser) => {
        return state.currentDealers;
    });
    const dealerDataInfo = useSelector((state: IUser) => {
        return state.dealerDataInfo;
    });
    const [brand, setBrand] = useState<string>('vw6');
    const [dealerID, setDealerID] = useState('');
    const [content, setContent] = useState<CreditStatusTableData[]>([]);
    const [failedSearchTerm, setFailedSearchTerm] = useState<string>('');
    const [loading, setLoading] = useState<boolean>(true);
    const [displayedContent, setDisplayedContent] = useState<
        CreditStatusTableData[]
    >([]);
    const [creditDetail, setCreditDetail] = useState<{
        applicationId: string;
        applicationNumber: number;
    }>(defaultDetail);
    const [sortType, setSortType] = useState<number>(
        CreditStatusTableSortType.SUBMITTED_DATE,
    );
    const [sortOrder, setSortOrder] = useState<boolean>(false);

    const { creditSearch } = useLocalization();

    useEffect(() => {
        if (currentDealers && dealerDataInfo) {
            const { dealer } = dealerDataInfo;
            setBrand(getBrandByDealerNumber(dealer.brand, dealer.dealerNumber));
            setDealerID(dealer.dealerNumber);
        }
    }, [dealerDataInfo]);

    useEffect(() => {
        if (creditDetail.applicationId !== DEFAULT_CREDIT_DETAILS) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'unset';
        }
    }, [creditDetail]);

    function selectContent() {
        return content.length > NO_RESULTS ? (
            <>
                <Table
                    items={displayedContent}
                    setDetail={setCreditDetail}
                    setSortOrder={setSortOrder}
                    setSortType={setSortType}
                    sortOrder={sortOrder}
                    sortType={sortType}
                />
                <TableFooter
                    brand={brand}
                    content={content}
                    setDisplayedContent={setDisplayedContent}
                />
            </>
        ) : (
            <NoContent failedSearchTerm={failedSearchTerm} />
        );
    }

    return dealerID ? (
        <>
            <div className='credit-status-wrapper'>
                <div className='page-title'>
                    <h5>{creditSearch.HEADER_LABEL}</h5>
                </div>
                <div className='credit-search-container'>
                    <Search
                        updateTableContent={setContent}
                        dealerID={dealerID}
                        setLoading={setLoading}
                        setFailedSearchTerm={setFailedSearchTerm}
                        sortOrder={sortOrder}
                        sortType={sortType}
                    />
                </div>
                <div
                    className={`content-container ${
                        content.length === NO_RESULTS || loading
                            ? 'no-content'
                            : ''
                    }`}
                >
                    {!loading ? selectContent() : loader}
                </div>
                <div className='privacy-footer-container '>
                    <FooterPrivacy />
                </div>
            </div>
            <>
                {creditDetail.applicationId !== DEFAULT_CREDIT_DETAILS && (
                    <DetailsDrawer
                        dealerId={dealerID}
                        applicationId={creditDetail.applicationId}
                        applicationNumber={creditDetail.applicationNumber}
                        close={() => setCreditDetail(defaultDetail)}
                    />
                )}
            </>
        </>
    ) : null;
};
export default CreditStatus;
